import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useWeb3React } from "@web3-react/core";
import { InjectedConnector } from "@web3-react/injected-connector";
import './Home.css';

const injectedConnector = new InjectedConnector({
  supportedChainIds: [1, 3, 4, 5, 42, 11155111, 80001, 199, 1029],
});

export default function Home() {
  const navigate = useNavigate();
  const [connected, setConnected] = useState(false);
  const [address, setAddress] = useState("");
  const { activate, active, account } = useWeb3React();
  const [type, setType] = useState("");
  const [isloading, setIsloading] = useState(false);

  useEffect(() => {
    if (account) {
      console.log("Account", account);
      setAddress(account);
      setIsloading(true);
    }
  }, [account]);

  const connectWallet = async () => {
    console.log("Connecting to wallet...");
    try {
      setIsloading(true);
      await activate(injectedConnector);
      console.log("wallet connected");
      console.log("Account", account);
      setConnected(true);
    } catch (error) {
      console.error("Failed to connect", error);
    }
    setIsloading(false);
  };

  const disconnectWallet = async () => {
    // Your disconnect logic here
    // Example: Deactivate the connector or clear account state
  };

  return (
    <div className="Container">
      <h1>DeSharableNotes</h1>
      {isloading ? (
        <button
          onClick={disconnectWallet}
          className="button button-loading"
        >
          Connected
        </button>
      ) : (
        <>
          {account && account.length ? (
            <button
              // onClick={disconnectWallet}
              className="button button-connect"
            >
              Connecting to wallet...
            </button>
          ) : (
            <button
              onClick={connectWallet}
              className="button button-connect"
            >
              Connect Wallet
            </button>
          )}
        </>
      )}
      <div className="mt-4">
        <button
          onClick={() => navigate("/about2")}
          className="button button-note-id"
        >
          Create Note with ID
        </button>
        <button
          onClick={() => navigate("/about1")}
          className="button button-note-no-id"
        >
          Create Note without ID
        </button>
      </div>
    </div>
  );
}
